import { render, staticRenderFns } from "./ModalMapObjectsSubType.vue?vue&type=template&id=4816cd42&"
import script from "./ModalMapObjectsSubType.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ModalMapObjectsSubType.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports